import { useEffect, useMemo, useRef, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  Button,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  FormControlLabel,
  Grid,
  Stack,
  TableHead,
  TableRow,
  Paper,
  styled,
  tableCellClasses,
  MenuItem,
  TextField,
  InputAdornment,
  TableCell,
  Tooltip,
  IconButton,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';

import useSettings from 'src/hooks/useSettings';
import useTable from 'src/hooks/useTable';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import {
  IElectricityPayment,
  IElectricityPaymentDetailsParam,
  IElectricityPaymentParams,
} from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';

import { useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import ContractInfoDetailsToolbar from './ElectricityPaymentDetailsToolbar';
import Loader from 'src/components/loader/Loader';
import { TableMoreMenu } from 'src/components/table';
import MyDialog from 'src/components/MyDialog';

import { RHFTextField } from 'src/components/hook-form';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { DateConverter } from 'src/sections/common/DateConverter';
import Label from 'src/components/Label';
import ELectricityRecievePayment from '../ElectricityPaymentForm/ELectricityRecievePayment';
import ElectricityPaymentbillDetailsToolbar from './ElectricityPaymentbillDetailsToolbar';
import ElectricityPaymentDetailsToolbar from './ElectricityPaymentDetailsToolbar';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
import ELectricConsumptionUpdate from './ELectricConsumptionUpdate';
import ElectricityPaymentDelete from './ElectricityPaymentDelete';
import ElectricityPaymentDetailTable from '../ElectricityPaymentDetails/ElectricityPaymentDetailTable';

// ----------------------------------------------------------------------
export default observer(function ElectricityPaymentList() {
  const { ElectricityPaymentStore } = useStore();
  const { translate } = useLocales();
  const {
    loadElectricityPayment,
    ElectricityPaymentList,
    openCreateDialog,
    setOpenCloseCreateDialog,
    loadElectricityPaymentDetail,
    setOpenCloseUpdateDialog,
    setOpenCloseDeleteDialog,
    openConsuptionDialog,
    setOpenCloseEletricDetailsDialog,
    openDeleteDialog,
    openEletricDetailsDialog
  } = ElectricityPaymentStore;

  const { themeStretch } = useSettings();
  const [isloading, setIsloading] = useState(false);
  const [year, setYear] = useState<string>(''); // State for the year
  const [month, setMonth] = useState<string>(''); // State for the month
  const [searchBy, setSearchBy] = useState<string>('');

  const [ElectricityPaymentId, setElectricityPaymentId] = useState<number>(0);

  //#region create modal
  const handleOpenCreateModal = async (param: IElectricityPaymentDetailsParam) => {
    await loadElectricityPaymentDetail(param).then(() => {
      setOpenCloseCreateDialog();
    });
  };

  const handleCloseCreateModal = () => {
    setOpenCloseCreateDialog();
  };
  //#endregion

  //#region
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const defaultValues = useMemo<IElectricityPaymentParams>(
    () => ({
      years: new Date(),
    }),
    []
  );
  const methods = useForm<IElectricityPaymentParams>({
    defaultValues,
  });
  const { watch, control } = methods;
  const yearsDate = watch('years'); // Watching the 'years' field

  useEffect(() => {
    if (yearsDate) {
      const changeDateToDateFormat = new Date(yearsDate);

      // Extract Persian year and month
      const persianYear = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        year: 'numeric',
      });
      const persianMonth = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        month: 'numeric',
      });

      // Convert Persian numerals to Western numerals
      const westernYear = persianYear.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );
      const westernMonth = persianMonth.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );

      // Update state with Western year and month
      setYear(westernYear);
      setMonth(westernMonth);
    }
  }, [yearsDate]);

  const Search = async (e: any) => {
    e.preventDefault();
    setIsloading(true);
    loadElectricityPayment({
      years: Number(year),
      months: Number(month),
      searchBy: searchBy,
    })
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
      });
  };
  useEffect(() => { }, [openMenu]);
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchBy(event.target.value); // Update state when input changes
  };

  const handleConsumption = (id: number) => {
    loadElectricityPaymentDetail({ electricityPaymentId: id }).then(() => {
      setOpenCloseUpdateDialog();
    });
  };

  const handleDelete = (id: number) => {
    loadElectricityPaymentDetail({ electricityPaymentId: id }).then(() => {
      setOpenCloseDeleteDialog();
      setElectricityPaymentId(id);
    });
  };

  const handleCloseConsumptionConfirm = () => {
    setOpenCloseUpdateDialog();
  };

  const handleCloseDeleteConfirm = () => {
    setOpenCloseDeleteDialog();
  };

  const handleOpenEletricDetailsModal = async (id: number) => {
    await loadElectricityPaymentDetail({ electricityPaymentId: id }).then(() => {
      setOpenCloseEletricDetailsDialog();

    });
  };

  const handleCloseEletricDetailsModal = () => {
    setOpenCloseEletricDetailsDialog();
  };

  const getUserDataFromLocalStorage: any = localStorage.getItem('userData');

  const changeLocalStorgeStringToValue = JSON.parse(getUserDataFromLocalStorage);

  const is_super_admin = changeLocalStorgeStringToValue.IsSuperAdmin;
  return (
    <Page title={translate('ElectricityPayment.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('ElectricityPayment.ElectricityPaymentList')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('ElectricityPayment.ElectricityPaymentList')}` },
          ]}
          action={
            <>
              <PermissionBasedGuard permissions={['ElectricityPayment-Create']}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  component={RouterLink}
                  to={PATH_DASHBOARD.ElectricityPayment.consumption}
                >
                  {translate('ElectricMeter.Consumption')}
                </Button>
              </PermissionBasedGuard>
            </>
          }
        />

        <Grid
          container
          display="flex"
          alignItems="center"
          justifyContent="center" // Use justifyContent instead of justifyItems
        >
          <Grid item xs={12} md={12} spacing={2}>
            <Card
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center', // Use justifyContent instead of justifyItems
              }}
            >
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' },
                  }}
                >
                  <LocalizDatePicker
                    name="years"
                    label={translate('Report.FromDate')}
                    control={control}
                    size={'small'}
                    views={['year', 'month']}
                  />
                  <TextField
                    name="searchBy"
                    fullWidth
                    placeholder={translate('RentPayment.SearchBy')}
                    size="small"
                    value={searchBy} // Bind the state to the TextField
                    onChange={handleSearchChange} // Handle changes
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Iconify
                            icon={'eva:search-fill'}
                            sx={{ color: 'text.disabled', width: 20, height: 20 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Button
                    sx={{ width: '120px' }}
                    variant="contained"
                    onClick={Search}
                    startIcon={<Iconify icon="eva:search-fill" />}
                  >
                    {/* {translate('Attendance.Filter')} */}
                    filter
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Use justifyContent instead of justifyItems
              >
                <ElectricityPaymentDetailsToolbar Report={ElectricityPaymentList} />

                <ElectricityPaymentbillDetailsToolbar Report={ElectricityPaymentList} />
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
          <>
            {isloading ? (
              <Loader />
            ) : (
              <>
                <Stack sx={{ p: 1 }}>
                  <TableContainer sx={{ maxHeight: 600 }} component={Paper}>
                    <Table stickyHeader sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <TableCell>{translate('ElectricityPayment.No')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.Year')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.Month')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.CustomerName')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.ShopCode')}</TableCell>
                          <TableCell>{translate('ElectricMeter.ElectricMeterSerial')}</TableCell>
                          <TableCell>{translate('ElectricBox.ElectricBoxCode')}</TableCell>
                          <TableCell>
                            {translate('ElectricityPayment.RecievedByUserName')}
                          </TableCell>
                          <TableCell>
                            {translate('ElectricMeter.LastElectricMeterDegree')}
                          </TableCell>
                          <TableCell>
                            {translate('ElectricityPayment.CurrentElectricMeterDegree')}
                          </TableCell>
                          <TableCell>{translate('ElectricityPayment.CurrentAmount')}</TableCell>
                          <TableCell>{translate('RentPayment.RemainFromThePast')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.PaymentAmount')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.PaidAmount')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.RemainAmount')}</TableCell>
                          <TableCell>{translate('ElectricityPayment.PaymentDate')}</TableCell>
                          <TableCell>{translate('GeneralFields.Action')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ElectricityPaymentList.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell align="center">
                              {' '}
                              <Label color="warning"> {row.year}</Label>
                            </TableCell>
                            <TableCell align="center">
                              <Label color="success"> {GetMonthName(row.month)}</Label>
                            </TableCell>
                            <TableCell align="center">{row.customerName}</TableCell>
                            <TableCell align="center">{row.shopCode}</TableCell>
                            <TableCell align="center">{row.electricMeterSerial}</TableCell>
                            <TableCell align="center">{row.electricBoxCode}</TableCell>
                            <TableCell align="center">{row.recievedByUserName}</TableCell>
                            <TableCell align="center">{row.previousElectricMeterDegree}</TableCell>
                            <TableCell align="center">{row.currentElectricMeterDegree}</TableCell>
                            <TableCell align="center">
                              {row.currentDateRangePayment} {GetCurrencySymbol('afn')}
                            </TableCell>
                            <TableCell align="center">
                              {row.remnantsOfThePast} {GetCurrencySymbol('afn')}
                            </TableCell>
                            <TableCell align="center">
                              {row.totalPayment} {GetCurrencySymbol('afn')}
                            </TableCell>
                            <TableCell align="center">
                              {row.paidAmount} {GetCurrencySymbol('afn')}
                            </TableCell>
                            <TableCell align="center">
                              {row.remainAmount === 0 ? (
                                <Label color="warning"> {translate('RentPayment.Paid')}</Label>
                              ) : (
                                ` ${row.remainAmount}  ${GetCurrencySymbol('afn')}`
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {row.paymentDate !== null ? (
                                <DateConverter date={row.paymentDate} />
                              ) : (
                                ''
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  gap: '16px',
                                }}
                              >
                                <PermissionBasedGuard
                                  permissions={['ElectricityPayment-RecieveElectricityPayment']}
                                >
                                  {row.remainAmount !== 0 && (
                                    <Tooltip title={translate('RentPayment.Recieve')}>
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={() => {
                                          if (row.electricityPaymentId) {
                                            handleOpenCreateModal({
                                              electricityPaymentId: row.electricityPaymentId,
                                            });
                                          }
                                        }}
                                      >
                                        <Iconify
                                          icon="eva:download-outline"
                                          width={20}
                                          height={20}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </PermissionBasedGuard>

                                {row.paidAmount === 0 && is_super_admin ? (
                                  <PermissionBasedGuard permissions={['ElectricityPayment-Update']}>
                                    {row.remainAmount !== 0 && (
                                      <Tooltip title={translate('ElectricityPayment.UpdateDegree')}>
                                        <IconButton
                                          color="warning"
                                          size="small"
                                          onClick={() => {
                                            if (row.electricityPaymentId) {
                                              handleConsumption(row.electricityPaymentId);
                                            }
                                          }}
                                        >
                                          <Iconify icon="eva:edit-outline" width={20} height={20} />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </PermissionBasedGuard>
                                ) : (
                                  ''
                                )}

                                {is_super_admin && (
                                  // <PermissionBasedGuard permissions={['ElectricityPayment-Delete']}>
                                  <Tooltip title={translate('CRUD.Delete')}>
                                    <IconButton
                                      color="error"
                                      size="small"
                                      onClick={() => {
                                        if (row.electricityPaymentId) {
                                          handleDelete(row.electricityPaymentId);
                                        }
                                      }}
                                    >
                                      <Iconify icon="eva:trash-2-outline" width={20} height={20} />
                                    </IconButton>
                                  </Tooltip>
                                  // </PermissionBasedGuard>
                                )}

                                <Tooltip title={translate('CRUD.Detail')}>
                                  <IconButton
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      if (row.electricityPaymentId) {
                                        handleOpenEletricDetailsModal(row.electricityPaymentId); // You should define this function
                                      }
                                    }}
                                  >
                                    <Iconify icon="eva:eye-outline" width={20} height={20} />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Stack>
              </>
            )}
            <MyDialog
              open={openConsuptionDialog}
              onClose={handleCloseConsumptionConfirm}
              title={translate('ElectricMeter.ElectricConsumption')}
              size="md"
            >
              <ELectricConsumptionUpdate
                year={Number(year)}
                month={Number(month)}
                searchBy={searchBy}
              />
            </MyDialog>
            <MyDialog
              open={openCreateDialog}
              onClose={handleCloseCreateModal}
              title={translate('ElectricityPayment.Title')}
              size="md"
            >
              <ELectricityRecievePayment
                ElectricityPaymentId={ElectricityPaymentId}
                year={Number(year)}
                month={Number(month)}
                searchBy={searchBy}
              />
            </MyDialog>

            <MyDialog
              open={openDeleteDialog}
              onClose={handleCloseDeleteConfirm}
              title={translate('ElectricityPayment.Delete')}
              size="md"
            >
              <ElectricityPaymentDelete
                id={ElectricityPaymentId}
                year={Number(year)}
                month={Number(month)}
                searchBy={searchBy}
              />
            </MyDialog>

            <MyDialog
              open={openEletricDetailsDialog}
              onClose={handleCloseEletricDetailsModal}
              title=""
              size="xl"
            >
              <ElectricityPaymentDetailTable

              />
            </MyDialog>
          </>
        </Grid>
      </Container>
    </Page>
  );
});
